import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Box, Breadcrumbs, Typography } from '@mui/material'

import { Circle } from '@mui/icons-material'
import Main from '@/views/layouts/main'
import ErrorLimit from '@/views/components/error-limit/index.component'

import ReportsModule from '@/views/reports/index.module'
import PageTitle from '@/views/layouts/page-title/index.layout'
import routes from '@/routes'

const ReportsPage = () => {
  const { t } = useTranslation()

  const breadcrumbs = (
    <Breadcrumbs separator={<Circle sx={{ fontSize: 6, marginX: 2 }} />}>
      <Link to={routes.HOME}>
        <Typography>{t('pages.home')}</Typography>
      </Link>
      <Typography>{t('pages.reports')}</Typography>
    </Breadcrumbs>
  )

  return (
    <Main>
      <ErrorLimit>
        <Box display="flex" mb={2}>
          <PageTitle title={t('pages.reports')} breadcrumbs={breadcrumbs} />
        </Box>
        <ReportsModule />
      </ErrorLimit>
    </Main>
  )
}

export default ReportsPage
